import { createAction } from 'redux-actions';
export const restrictLoggedOut = createAction('@@loggedOut/RESTRICT_ACCESS', (payload)=>payload);
// this is an easy way to wrap existing actions to check for logged out
// but do remember that any reducers/sagas need to handle the _wrapped_ action
// so you must have access to the original action type
// the whole type/function jugglery here is to ensure proper typings in the result
export const VERIFY_ACCESS = '@@loggedOut/VERIFY_ACCESS';
export const verifyLoggedOutAccess = (restrictedActionName, actionCreator)=>(...args)=>({
            type: VERIFY_ACCESS,
            payload: {
                action: actionCreator(...args),
                restrictedActionName
            }
        });
